module.exports = __webpack_public_path__ + "static/assets/6c501070a8f69db211a7d85593d860f8.svg";